/* eslint-disable arrow-body-style */
import { HISTORY_ACTION_COLORS } from 'constant';
import PropType from 'prop-types';

const TimeLineCard = ({ action, headerPrimary, headerSecondary, description, footer }) => {
    const actionClassName = action ? action.toLowerCase().replace(/\s+/g, '') : '';

    const customColor = (action && (HISTORY_ACTION_COLORS[action] || HISTORY_ACTION_COLORS[action.toLowerCase()])) || '';

    return (
        <div className={`timeline__card card timeline__${action === 'goal progress' ? 'goalprogress' : actionClassName}`}>
            <header className="card__header">
                <time className="time">
                    <span className="time__day">{headerPrimary}</span>
                    <span className="time__month">{headerSecondary}</span>
                </time>
                <span className="timeline__action" style={customColor ? { backgroundColor: customColor, color: '#fff' } : {}}>
                    {action}
                </span>
            </header>
            <div className="card__content">
                <p>
                    {description} {footer && <span>by</span>} {footer}
                </p>
            </div>
        </div>
    );
};

TimeLineCard.propTypes = {
    action: PropType.string,
    headerPrimary: PropType.string,
    headerSecondary: PropType.string,
    description: PropType.string,
    footer: PropType.string
};

export default TimeLineCard;
